<template>
  <lw-overlay
    v-if="!ratesLoading"
    :size="'c1'"
    :colour="'grey-300'"
  >
    <header class="grid mb1">
      <h1 class="order-1 order-0_sm">Edit {{ rate.name }}</h1>
      <div class="align-right order-0 order-1_sm"><button
        class="invisible-button"
        @click.prevent="duplicate"><svg-duplicate/> Make a copy</button></div>
    </header>
    <form
      class="grid grid-columns-2_sm"
      @submit.prevent="editRate">
      <fieldset class="subtle p2">
        <h2>Rate card details</h2>
        <hr class="mb2 c1">
        <lw-text-input
          v-validate="'required'"
          :label="'Rate card name'"
          :name="'name'"
          :type="'text'"
          :size="'large'"
          :kind="'font-size-7 display bold'"
          v-model="name"
          :error="errors.first('name')"
        />
        <lw-text-area
          :label="'Description'"
          :name="'description'"
          :kind="'font-size-4 sans'"
          :size="'large'"
          v-model="description"
        />
      </fieldset>
      <fieldset class="subtle p2">
        <h2>Rates</h2>
        <hr class="mb2">
        <div>
          <lw-currency-input
            :name="'monthRate'"
            :label="'Monthly rate'"
            :hint="'Per person, per client'"
            :align="'right'"
            :size="'large'"
            :currency="organization.currency"
            v-model.number="monthRate"
          />
          <lw-currency-input
            :name="'sprintRate'"
            :label="'Sprint rate'"
            :hint="'Per person, per client'"
            :align="'right'"
            :size="'large'"
            :currency="organization.currency"
            v-model.number="sprintRate"
          />
          <lw-currency-input
            :name="'weekRate'"
            :label="'Weekly rate'"
            :hint="'Per person, per client'"
            :align="'right'"
            :size="'large'"
            :currency="organization.currency"
            v-model.number="weekRate"
          />
          <lw-currency-input
            :name="'dayRate'"
            :label="'Day rate'"
            :hint="'Per person'"
            :align="'right'"
            :size="'large'"
            :currency="organization.currency"
            v-model.number="dayRate"
          />
          <lw-currency-input
            :name="'hourRate'"
            :label="'Hourly rate'"
            :hint="'Per person'"
            :align="'right'"
            :size="'large'"
            :currency="organization.currency"
            v-model.number="hourRate"
          />
        </div>
      </fieldset>
      <div class="grid-column-full mt1 mb-margin">
        <button
          v-shortkey="['meta', 's']"
          class="accent-button large-button full-button_mb mr1"
          type="submit"
          @shortkey="editRate">Save</button>
        <button
          class="invisible-button negative-button"
          @click.prevent="close">Cancel</button>
        <button
          class="invisible-button negative-button right"
          @click.prevent="isConfirming = true"><svg-archive/> Archive rate card</button>
      </div>
    </form>
    <app-archive-rate
      v-if="isConfirming"
      :name="rate.name"
      :page="page"
      :is-confirming.sync="isConfirming"/>
  </lw-overlay>
</template>

<script>
import { mapGetters } from 'vuex'
import TextInput from '../livewires/TextInput'
import TextArea from '../livewires/TextArea'
import CurrencyInput from '../livewires/CurrencyInput'
import Overlay from '../livewires/Overlay'
import ArchiveRate from './ArchiveRate'
import Duplicate from '../svgs/Duplicate'
import Archive from '../svgs/Archive'

export default {
  components: {
    lwTextInput: TextInput,
    lwTextArea: TextArea,
    lwCurrencyInput: CurrencyInput,
    lwOverlay: Overlay,
    appArchiveRate: ArchiveRate,
    svgDuplicate: Duplicate,
    svgArchive: Archive
  },
  data () {
    return {
      page: this.$route.params.id,
      isConfirming: false,
      name: '',
      description: '',
      monthRate: '',
      sprintRate: '',
      weekRate: '',
      dayRate: '',
      hourRate: ''
    }
  },
  computed: {
    ...mapGetters([
      'organization',
      'ratesLoading',
      'user'
    ]),
    rate () {
      return this.$store.getters.rateCard(this.page)
    }
  },
  created () {
    this.name = this.rate.name
    this.description = this.rate.description
    this.monthRate = this.rate.monthRate
    this.sprintRate = this.rate.sprintRate
    this.weekRate = this.rate.weekRate
    this.dayRate = this.rate.dayRate
    this.hourRate = this.rate.hourRate
  },
  methods: {
    editRate () {
      this.$store.dispatch('saveState', false)
      let payload = { ...this.rate }
      payload.name = this.name
      payload.description = this.description
      payload.monthRate = this.monthRate
      payload.sprintRate = this.sprintRate
      payload.weekRate = this.weekRate
      payload.dayRate = this.dayRate
      payload.hourRate = this.hourRate
      payload.id = this.page
      this.$store.dispatch('editRateCard', payload).then(response => {
        this.$router.push({ name: 'simpleRate', params: { id: this.page } })
        this.$emit('rateSettings', 'updated')
      })
    },
    close () {
      this.$router.push({ name: 'simpleRate', params: { id: this.page } })
    },
    duplicate () {
      this.$store.dispatch('toggleLoading', true)
      this.$store.dispatch('saveState', false)
      const payload = { ...this.rate }
      this.$store.dispatch('duplicateRate', payload).then(response => {
        this.$router.push({ name: 'rates' })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 48em) {
  header {
    grid-template-columns: auto auto;
    align-items: baseline;
  }
}
</style>
